import _KpiDefinitionData from "./KpiDefinitionData.json";

export default {
  ..._KpiDefinitionData
};
